import { FC } from "react";
import { OrganizationSwitcher } from "@components/navigation/OrganizationSwitcher";
import { useOrganization } from "@api/organization.api";
import { Menu } from "@design-system/Menu/Menu.lib";

/** The personal menu's items: the organization switcher, when the user has one. */
export const PersonalViewNavigationDropdownBody: FC = () => {
    const userOrganization = useOrganization();

    return (
        <>
            {userOrganization && (
                <>
                    <OrganizationSwitcher />
                    <Menu.Separator />
                </>
            )}
        </>
    );
};
